<template>
  <v-container class="ma-0 pa-0 fluid">
    <v-app-bar app elevation="0" color="#1c3664" height="120" absolute>
      <v-toolbar-title>
        <div class="rounded-circle">
          <v-img v-if="showImage1" :src="image1" height="50"></v-img>
          <v-img v-else :src="image2" height="50"></v-img>
        </div>
      </v-toolbar-title>
      <v-list style="background-color: transparent">
        <router-link v-for="link in links" :key="link.path" :to="link.path"
          ><v-btn class="btnNav">{{ $t(`${link.title}`) }}</v-btn></router-link
        >
      </v-list>
      <v-spacer></v-spacer>
      <!-- <v-btn v-if="isAuth" @click="logout" >{{ $t("logout") }} </v-btn> -->
      <v-btn v-if="isAuth" @click="logout" icon="mdi-export"></v-btn>
    </v-app-bar>
  </v-container>
</template>

<script>
import auth from "@/store/auth";
export default {
  name: "NavBar",
  props: {
    dir: String,
    links: [],
    isAuth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showImage1: true,
      image1: "/images/logo1.svg",
      image2: "/images/logo2.svg",
    };
  },
  methods: {
    logout() {
      auth.logout();
    },
  },
  mounted() {
    setInterval(() => {
      this.showImage1 = !this.showImage1;
    }, 2000);
  },
};
</script>

<style scoped>
.btnNav {
  color: white;
  font-family: tajawal;
  font-weight: bold;
  margin-left: 0px;
  margin-right: 0px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 0px;
  padding-bottom: 0px;
  border-left: 0.5px solid white;
  border-right: 0.5px solid white;

  border-radius: 0px;
}

.btnLang {
  font-size: 12px;
  color: white;
  border: 2px white solid;
  padding: 0px;
  margin: 0px;
  width: auto;
}
</style>
